/**
 * Search page enhancements
 */
export function initSearch() {
    const searchForm = document.querySelector('form[role="search"]');
    const searchInput = searchForm?.querySelector('input[type="search"]');
    
    if (!searchForm || !searchInput) return;

    // Auto-focus search input if there's a keyword parameter
    const urlParams = new URLSearchParams(window.location.search);
    const hasKeyword = urlParams.get('keyword');
    
    if (!hasKeyword) {
        searchInput.focus();
    }

    // Add loading state on form submit
    searchForm.addEventListener('submit', (e) => {
        const submitButton = searchForm.querySelector('button[type="submit"]');
        if (submitButton && searchInput.value.trim()) {
            submitButton.classList.add('opacity-75', 'pointer-events-none');
        }
    });

    // Clear empty search
    searchInput.addEventListener('input', (e) => {
        const value = e.target.value.trim();
        if (!value) {
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('keyword')) {
                // If there was a previous search, allow clearing it
                const form = e.target.closest('form');
                if (form) {
                    setTimeout(() => {
                        window.location.href = form.action;
                    }, 300);
                }
            }
        }
    });

    // Highlight search terms in results (optional enhancement)
    highlightSearchTerms();
}

function highlightSearchTerms() {
    const urlParams = new URLSearchParams(window.location.search);
    const keyword = urlParams.get('keyword');
    
    if (!keyword) return;

    const searchTerms = keyword.toLowerCase().split(' ').filter(term => term.length > 2);
    const results = document.querySelectorAll('article p, article h3 a');
    
    results.forEach(element => {
        const text = element.textContent;
        let highlightedText = text;
        
        searchTerms.forEach(term => {
            const regex = new RegExp(`(${term})`, 'gi');
            highlightedText = highlightedText.replace(regex, '<mark class="bg-[#E7B05D]/30 px-2 rounded">$1</mark>');
        });
        
        if (highlightedText !== text) {
            element.innerHTML = highlightedText;
        }
    });
}
